import * as React from "react";
import clsx from "clsx";
import { makeStyles, Theme, createStyles, Card, Grid, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import InstallationLevelConsumptionFilter from "../../../components/InstallationFilterComponents/LevelConsumptionFilter";
import SmartSelectBaseFilter from "../../../core/models/SmartSelectBaseFilter";
import ButtonExport from "../../../components/ButtonExport";
import { EVENT_EXPORT_EXCEL_LEVEL_HISTORY, EVENT_EXPORT_PDF_LEVEL_HISTORY } from "../../../Events";
import { useHubx } from "../../../HubX";
import SmartSelect from "../../SmartFilters/SmartSelect";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "background": theme.customPaper.background.cardBackgroundLight,
      "padding": theme.spacing(2),
      "display": "flex",
      "flexDirection": "column",

      "& .selector": {
        display: "flex",
        alignItems: "center",
        color: theme.palette.text.secondary,
        columnGap: `${theme.spacing(1)}px`,
        maxWidth: 500,
        maxHeight: 120,
        overflow: "auto",
      },
    },

    gridRoot: {
      alignItems: "center",
      columnGap: theme.spacing(1),
    },

    filtersWrapper: {
      flex: 1,
    },

    childrenWrapper: {
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "flex-end",
      "flex": 1,

      "& > *:not(first-child)": {
        marginLeft: theme.spacing(4),
      },

      "&.alt": {
        "marginTop": theme.spacing(3),
        "justifyContent": "flex-start",

        "& > *": {
          marginRight: theme.spacing(4),
          marginLeft: 0,
        },
      },
    },

    hidden: {
      display: "none",
    },
  })
);

type InstallationFilterProps = {
  selectedTab: number;
  isLoading: boolean;
  installationFilter?: SmartSelectBaseFilter;
  customerFilter?: SmartSelectBaseFilter;
  statusFilter?: SmartSelectBaseFilter;
};

function ReportFilter(props: InstallationFilterProps) {
  const {
    selectedTab,
    installationFilter,
    customerFilter,
    statusFilter,
    isLoading = false,
  } = props;

  const classes = useStyles();
  const hub = useHubx();

  const handleClickExportExcel = () => {
    hub.notify(EVENT_EXPORT_EXCEL_LEVEL_HISTORY);
  };

  const handleClickExportPdf = () => {
    hub.notify(EVENT_EXPORT_PDF_LEVEL_HISTORY);
  };

  return (
    <Card className={classes.root}>
      <div>
        <Grid className={classes.gridRoot} container spacing={2}>
          <Grid item xs="auto">
            <div className={"selector"}>
              {customerFilter && !isLoading && (
                <>
                  <Typography> Grupo de Instalações: </Typography>
                  <SmartSelect
                    options={customerFilter.options}
                    getOptionLabel={customerFilter.getOptionLabel}
                    value={customerFilter.value}
                    onChange={customerFilter.onChange}
                  />
                </>
              )}
              {isLoading && <Skeleton width={400} height={40} />}
            </div>
          </Grid>

          <Grid item>
            {installationFilter && !isLoading && (
              <div className={"selector"}>
                <Typography> Instalação: </Typography>
                <SmartSelect
                  options={installationFilter.options}
                  getOptionLabel={installationFilter.getOptionLabel}
                  value={installationFilter.value}
                  onChange={installationFilter.onChange}
                />
              </div>
            )}
          </Grid>

          {installationFilter && statusFilter && selectedTab === 0 && (
            <Grid item>
              <SmartSelect
                options={statusFilter.options}
                getOptionLabel={statusFilter.getOptionLabel}
                value={statusFilter.value}
                onChange={statusFilter.onChange}
              />
            </Grid>
          )}

          <Grid item className={classes.filtersWrapper}>
            <div className={clsx(selectedTab !== 0 && classes.hidden, classes.childrenWrapper)}>
              <ButtonExport
                label="Exportar"
                onClickExcel={() => handleClickExportExcel()}
                onClickPdf={() => handleClickExportPdf()}
              />
            </div>
          </Grid>
        </Grid>
      </div>

      <div className={clsx(selectedTab !== 1 && classes.hidden, classes.childrenWrapper, "alt")}>
        <InstallationLevelConsumptionFilter />
      </div>
    </Card>
  );
}

export default ReportFilter;
